import Vuex from 'vuex'
import Vue from 'vue'

Vue.use(Vuex)
import axios from 'axios'
import jwt_decode from 'jwt-decode'


export const store = new Vuex.Store({
  state: {
     accessToken: localStorage.getItem('access_token') || null, // makes sure the user is logged in even after
    // refreshing the page
     refreshToken: localStorage.getItem('refresh_token') || null,
     APIData: '', // received data from the backend API is stored here.
    globalTheme:null
  },

  getters: {
    loggedIn (state) {
      return state.accessToken != null
    },
    siteDataLoaded(state){
      return state.globalTheme != null
    }
  },
  mutations: {
    updateSiteSettings(state,siteSettings){
      state.globalTheme = siteSettings
    },
    updateLocalStorage (state, { access, refresh }) {
      localStorage.setItem('access_token', access)
      localStorage.setItem('refresh_token', refresh)
      state.accessToken = access
      state.refreshToken = refresh
    },
    updateAccess (state, access) {
      localStorage.setItem('access_token', access)
      state.accessToken = access
    },
    destroyToken (state) {
      state.accessToken = null
      state.refreshToken = null
    }
  },
  actions: {
    // run the below action to get a new access token on expiration
    refreshToken(context) {
      return new Promise((resolve, reject) => {
        axios.post('/api/account/token/refresh/', {
          refresh: context.state.refreshToken
        }) // send the stored refresh token to the backend API
          .then(response => { // if API sends back new access and refresh token update the store
            console.log('New access successfully generated')
            context.commit('updateAccess', response.data.access)

            resolve(response.data.access)
          })
          .catch(err => {
            console.log('error in refreshToken Task')
            localStorage.removeItem('access_token')
            localStorage.removeItem('refresh_token')
            context.commit('destroyToken')
          })
      })
    },
    registerUser(context, data) {
      return new Promise((resolve, reject) => {
        axios.post('/api/account/register/', {
          email: data.email,
          password: data.password,
          vouchercode: data.vouchercode
        })
          .then(response => {
            context.commit('updateLocalStorage', {access: response.data.tokens.access, refresh: response.data.tokens.refresh}) // store the access and refresh token in localstorage
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    logoutUser(context) {
      if (context.getters.loggedIn) {
        return new Promise((resolve, reject) => {
          axios.post('/api/account/token/logout/')
            .then(response => {
              localStorage.removeItem('access_token')
              localStorage.removeItem('refresh_token')
              context.commit('destroyToken')
            })
            .catch(err => {
              localStorage.removeItem('access_token')
              localStorage.removeItem('refresh_token')
              context.commit('destroyToken')
              resolve(err)
            })
        })
      }
    },
    loginUser(context, credentials) {
      return new Promise((resolve, reject) => {
        // send the username and password to the backend API:
        axios.post('/api/account/token/', {
          email: credentials.email,
          password: credentials.password
        })
        //if successful update local storage:
          .then(response => {
            context.commit('updateLocalStorage', {access: response.data.access, refresh: response.data.refresh}) // store the access and refresh token in localstorage
            resolve()
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    inspectToken(context) {
      const token = context.state.accessToken;
      console.log('here');
      if (token) {
        const decoded = jwt_decode(token)
        const exp = decoded.exp
        const orig_iat = decoded.orig_iat
        console.log((exp - (Date.now() / 1000)))
        console.log(orig_iat)
        if ((exp - (Date.now() / 1000)) < 200) {
          console.log('this');
          context.dispatch('refreshToken',context)
        } else {
          // PROMPT USER TO RE-LOGIN, THIS ELSE CLAUSE COVERS THE CONDITION WHERE A TOKEN IS EXPIRED AS WELL
        }
      }

    },

    loadSiteSettings(context){
      axios.get('/api/v1/site/').then(response=> {
            console.log(response)
            context.commit('updateSiteSettings', response.data) // store the access and refresh token in localstorage
            })
    }
  }
})




// WEBPACK FOOTER //
// ./src/store/store.js